import { useState, Fragment } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Dialog, Transition } from "@headlessui/react";
import MainLayout from "@layouts/MainLayout";
import Button from "@components/Button";
import packages from "@data/PackagesData"; // Import the packages data

function PackageInfo() {
	const { packagename } = useParams(); // Capture the packagename from the URL
	const [isModalVisible, setIsModalVisible] = useState(false);

	// Find the package data based on the packagename
	const packageData = packages.find(
		(pkg) => pkg.title.toLowerCase().replace(/\s+/g, "-") === packagename
	);

	const handlePurchase = () => {
		const purchasedPackages =
			JSON.parse(localStorage.getItem("purchasedPackages")) || [];
		const newPackage = {
			title: packageData.title,
			price: packageData.price,
			description: packageData.description,
		};
		purchasedPackages.push(newPackage);
		localStorage.setItem(
			"purchasedPackages",
			JSON.stringify(purchasedPackages)
		);
		setIsModalVisible(true);
		setTimeout(() => {
			setIsModalVisible(false);
		}, 2000);
	};

	if (!packageData) {
		return (
			<MainLayout>
				<div className="container mx-auto p-6">
					<h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
						Package not found
					</h1>
				</div>
			</MainLayout>
		);
	}

	return (
		<MainLayout
			heroImageName="banner1-notext"
			heroShowText={true}
			heroHeading="About Package"
		>
			<div className="p-6 text-center items-center justify-center flex flex-col space-y-6">
				<h1 className="font-bold font-switzer text-black text-4xl text-center lg:xl:text-5xl dark:text-white">
					{packageData.title}
				</h1>
				<p className="font-switzer font-semibold text-[#FF7800] text-xl xl:lg:text-4xl py-4">
					${packageData.price}
					<span className="text-gray-600 dark:text-gray-200 text-base font-extralight">
						/ package
					</span>
				</p>
				<p className="text-gray-700 dark:text-gray-300 mb-6 xl:lg:w-1/2 font-light">
					{packageData.description}
				</p>
				<Button
					buttonName="Purchase"
					buttonStyle="primary"
					onClick={handlePurchase}
				/>
			</div>

			<Transition appear show={isModalVisible} as={Fragment}>
				<Dialog
					as="div"
					className="relative z-50"
					open={isModalVisible}
					onClose={() => setIsModalVisible(false)}
				>
					{/* The backdrop, rendered as a fixed sibling to the panel container */}
					<div className="fixed inset-0 bg-black/30" aria-hidden="true" />

					{/* Full-screen container to center the panel */}
					<div className="fixed inset-0 flex justify-center items-center p-4">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
							<Dialog.Panel className="bg-[#FF7800] dark:bg-gray-700 mx-auto p-12 rounded max-w-lg">
								<Dialog.Title
									as="h3"
									className="font-maitree font-medium text-4xl text-center text-gray-900 dark:text-white leading-6"
								>
									Purchase Successful!
								</Dialog.Title>
								<Dialog.Description className="mt-4 font-cabin text-center text-gray-200 text-lg dark:text-gray-300">
									Package purchased successfully!
								</Dialog.Description>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition>
		</MainLayout>
	);
}

PackageInfo.propTypes = {
	packageData: PropTypes.object,
};

export default PackageInfo;
